<template>
  <div>
    <el-form class="tw-flex tw-justify-between">
      <div class="tw-flex tw-items-center">
        <i-button
          type="white"
          size="large"
          is-icon
          :disabled="!previous"
          @click="() => updateFilter('page', filters.page - 1)"
        >
          <icon-angle-left />
        </i-button>
        <div class="tw-px-5">
          {{ filters.page }}
        </div>
        <i-button
          type="white"
          size="large"
          is-icon
          :disabled="!next"
          @click="() => updateFilter('page', filters.page + 1)"
        >
          <icon-angle-right />
        </i-button>
      </div>

      <div class="tw-mr-14 tw-w-40">
        <el-form-item
          label="Rows per pages"
        >
          <el-select
            :model-value="filters.page_size"
            placeholder=""
            @change="(payload) => updateFilter('page_size', payload)"
          >
            <el-option
              v-for="item in [10, 20, 50, 100]"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.foreigners.foreigners.filters,
      previous: (state) => state.v2.admin.foreigners.foreigners.previous,
      next: (state) => state.v2.admin.foreigners.foreigners.next,
    }),
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field, payload });
    },
  },
};
</script>
